import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
//import {AlertProvider} from 'react-native-async-alert';
//import {useShowAlert} from 'react-native-async-alert';
import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');



const RenderWpSummary = () => {


const resturl=sessionStorage.getItem("RESTURL");
const navWpapps = React.useRef();

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [tblwpfverify, setTblwpfverify] = useState([]);
//const [combolocation, setCombolocation] = useState([]);

const [renders, setRenders] = useState({count:0});
const [wptapp, setWptapp] = useState({WPT_APP_ID:0});
const [dowait, setDowait] = useState({show: false});
const [dowaitdl, setDowaitdl] = useState({show: false});
const [caseworkeroptions, setCaseworkeroptions] = useState([]);
const [arraycaseworker, setArraycaseworker] = useState([]);

const [arroccupcateg, setArroccupcateg] = useState([]);
const [occupcategoptions, setOccupcategoptions] = useState([]);


const [TOTAL_EMPTY_FIELDS, setTOTAL_EMPTY_FIELDS] = useState({NUM:500});
const [nextpg, setNextpg] = useState({name:""});
const [agency, setAgency] = useState({CASE_WORKER:""});


const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "APS Summary";	

if (location.state.wptapp){
	setWptapp(location.state.wptapp);
	}//end if
else
	console.log("location.state.WPT_APP_ID not provided");
	//qrylabor();
 },[]);

useEffect(() => {
//console.log("useEffect"+wptapp.WPT_APP_ID);
if (wptapp.WPT_APP_ID>0){
	console.log('wptapp.APP_TYPE_ID'+wptapp.APP_TYPE_ID)
	if (!wptapp.REF_NUM)
		return;
	
	if (tblwpfverify.length<1)
		gettblwpfverify();
		
	const PROCESS_AREA=wptapp.PROCESS_AREA??"";
	const name=(PROCESS_AREA=="Government")?"gvtapps":"wpapps";
	setNextpg({name:name});		
		
	}//end if
 },[wptapp]);


useEffect(() => {

if (tblwpfverify.length>0 && arraycaseworker.length==0)
	getcaseworkerareas();
	
 },[JSON.stringify(tblwpfverify)]);


useEffect(() => {

if (arroccupcateg.length>0 && occupcategoptions.length==0)
	writeoccupcategoptions();
	
 },[JSON.stringify(arroccupcateg)]);



useEffect(() => {

if (occupcategoptions.length<=0 || arroccupcateg.length<=0)
	return;
	
	for (var i=0; i<arroccupcateg.length; i++){
		const occupcateg=arroccupcateg[i];
		if (occupcateg.SELECTED==1){
			setWptapp((prev)=>{
				return {
					...prev
					, OCC_CAT_ID: occupcateg.OCC_CAT_ID
					}
				});
			console.log("after set wptapp.OCC_CAT_ID to occupcateg.OCC_CAT_ID: "+occupcateg.OCC_CAT_ID);
			}//end if
		}//end for
	
 },[JSON.stringify(occupcategoptions)]);


useEffect(() => {

setCaseworkeroptions([]);
console.log("arraycaseworker.length: "+arraycaseworker.length);

if (wptapp.PROCESS_AREA!="" && arraycaseworker.length>0){
	callsetCaseworkeroptions(true);
	getwpformoptions();
	}
	

if (document.getElementById("filtercw"))
	document.getElementById("filtercw").checked=true;

 },[arraycaseworker.length]);





async function getoccupcategoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {OCCUPATION:wptapp.MPE_OCCUPATION} )
  };		
	setOccupcategoptions([]);
	setArroccupcateg([]);
	
  await fetch(resturl+'rarwpform/getoccupcategoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetoccupcategoptions(res) )
      .catch(err => console.log(err));

}//end func


function aftergetoccupcategoptions(res){
	
	
	if (!res.length)
		return;
let temp=[];
res.map((col, index) => {
	
	temp.push({
		OCC_CAT_ID: col['OCC_CAT_ID']
		, CATEGORY_DESC: col['CATEGORY_DESC']
		, SELECTED: col['SELECTED']
	});
	});//end map
	
setArroccupcateg(temp);

}//end func

function writeoccupcategoptions(){
	
if (!arroccupcateg.length)
	return;

let temp=[];
arroccupcateg.map((col, index) => {
	
	const key="uccpcategopt_"+index;
	temp.push(<option value={col['OCC_CAT_ID']} >{col['CATEGORY_DESC']}</option>);
	});//end map
	
setOccupcategoptions(temp);


}//end func




async function getcaseworkerareas(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		
	setCaseworkeroptions([]);
	
  await fetch(resturl+'rarwpform/getcaseworkerareas',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetcaseworkerareas(res) )
      .catch(err => console.log(err));

}//end func

function aftergetcaseworkerareas(res){
	
	getoccupcategoptions();
	
	if (!res.length)
		return;
let temp=[];
res.map((col, index) => {
	const combo=col['COMBO'];
//	const key=combo+"_"+index;
	temp.push({
		USERNAME:col['USERNAME']
		, FULLNAME:col['FULLNAME']
		, TC_ISLAND:col['TC_ISLAND']
		, PROCESS_AREA:col['PROCESS_AREA']
		});
	});//end map
	
setArraycaseworker(temp);


}//end func



async function caseworkerbatchupdate(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID: wptapp.WPT_APP_ID} )
  };		

 await fetch(resturl+'rarwpform/caseworkerbatchupdate',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercaseworkerbatchupdate(res) )
      .catch(err => console.log(err));

}//end func

function aftercaseworkerbatchupdate(res){

const CASE_WORKER=res.length?(res[0].CASE_WORKER??""):"";
if (CASE_WORKER=="")
	window.alert("attempt to assign a Case Worker seems to have failed");
else
	setAgency({CASE_WORKER:CASE_WORKER});

}//end func	


async function getwpformoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		

 await fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));

}//end func




function aftergetwpformoptions(res){

const PROCESS_AREA=""+(wptapp.PROCESS_AREA);

if (PROCESS_AREA.toUpperCase()=="GENERAL")
	caseworkerbatchupdate();

let templocation=[];

/*
res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='location' && !strOption.toUpperCase().includes("UNKNOWN"))
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
	
	});//end map
setCombolocation(templocation);
*/

}//end func


function gettblwpfverify(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID} )
  };		

  fetch(resturl+'rarwpform/gettblwpfverify',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwpfverify(res) )
      .catch(err => console.log(err));

}//end func

function aftergettblwpfverify(res){
if (res.length==undefined)
	return;
	
console.log('aftergettblwpfverify, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	if (index==1)
		setTOTAL_EMPTY_FIELDS({NUM:col['TOTAL_EMPTY_FIELDS']});
	
	const SCTN=col['SCTN'];
	const SHORT_NAME=col['SHORT_NAME'];
	const NUM_FLD_RQD=col['NUM_FLD_RQD'];
	const NUM_DATA=col['NUM_DATA'];
	
	const MPT_FLD=col['MPT_FLD'];
	const trkey='tr_'+index;
	const tdkey='td_'+index;
	const rdkey='td_'+index;
	const ok=(NUM_FLD_RQD>NUM_DATA)?<img src='img/alert.png' height='18' border='0' />:<img src='img/greentick.png' height='18' border='0' />
	
	const htmrow=<tr key={trkey} >
	<td align='left' key={tdkey}  >{1+index}:&nbsp;{SHORT_NAME}</td>
	<td align='center' key={'c3'+tdkey}  >{NUM_FLD_RQD}</td>
	<td align='center' key={'c4'+tdkey}  >{NUM_DATA}</td>
	<td align='center' key={'c5'+tdkey}  >{ok}</td>
	<td align='left' key={'c6'+tdkey}  >{MPT_FLD}</td>
	</tr>;
	htmrows.push(htmrow);
});

setTblwpfverify(htmrows);
}//end func


function handleChange(e){
let {name, value}=e.target;

setWptapp((prev) => {
return {...prev, [name]:value}
});

}//end func

async function submitwptapp(e){
	e.preventDefault();
	
	
	if (TOTAL_EMPTY_FIELDS.NUM>0){
		showsnackbar(TOTAL_EMPTY_FIELDS.NUM+' mandatory fields remain to be populated');
		return;
		}//end if
	
	const OCC_CAT_ID = wptapp.OCC_CAT_ID??0;
	if (1*OCC_CAT_ID==0){
		window.alert('Business Type is mandatory');
		return;
		}


	const TC_ISLAND = wptapp.TC_ISLAND??"";
	if (TC_ISLAND.trim()==""){
		window.alert('Location is mandatory');
		return;
		}
	
	setDowait({show:true});
	
//	e.preventDefault();
const params={
	WPT_APP_ID:wptapp.WPT_APP_ID
	, CASE_WORKER:wptapp.CASE_WORKER
	, OCC_CAT_ID:wptapp.OCC_CAT_ID
, TC_ISLAND:wptapp.TC_ISLAND
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwpform/submitwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersubmitwptapp(res) )
      .catch(err => console.log(err));

//return false;

}//end func

function aftersubmitwptapp(res){
	
	setDowait({show:false});
	let UPDATE_COUNT=0;
	
	if (res.length)
		if (res.length==1)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
		
	if (UPDATE_COUNT==1)
		toggleModalsm();//alert('applcation has been submitted')
	else
		showsnackbar("something wen wrong.<br/>please check the year on the dates and try again or contact admin");
	
	
//	console.log('res.myhref: '+res.myhref);
//window.open(res.myhref);

}//end func

function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function callsetWptapp(e){
	const [attribNam, attribVal]=[e.target.name, e.target.value];
	console.log('callsetWptapp attribNam: '+attribNam);
setWptapp((prev) => {
return {...prev, [attribNam]:attribVal}
});

//if (attribNam=='TC_ISLAND')
	//document.getElementsByName('IMG_REF')[0].focus();

}//end func

function callsetCaseworkeroptions(filtercw){
	
console.log("wptapp.TC_ISLAND: "+wptapp.TC_ISLAND);
console.log("wptapp.PROCESS_AREA: "+wptapp.PROCESS_AREA);
console.log("filtercw: "+filtercw);

let temp=[];
for (var i=0; i<arraycaseworker.length; i++){
	const cw=arraycaseworker[i];
	const key="cwopt_"+i;

	if (filtercw==true){
		if (cw.TC_ISLAND.toUpperCase()==wptapp.TC_ISLAND.toUpperCase() && cw.PROCESS_AREA==wptapp.PROCESS_AREA)
			temp.push(<option key={key} value={cw.USERNAME} >{cw.FULLNAME}</option>);
		}//end if
	else
		temp.push(<option key={key} value={cw.USERNAME} >{cw.FULLNAME}</option>);
	
	}//end for
setCaseworkeroptions(temp);
console.log("temp.length: "+temp.length);
	
	
}//end func

const refnum=wptapp.REF_NUM;
const refurl=sessionStorage.getItem("UPLOADURL")+refnum+"/";
console.log('refurl: '+refurl);
//const caseWorker=sessionStorage.getItem("CASE_WORKER")?sessionStorage.getItem("CASE_WORKER"):"";
/*
case woker input is mandatory for corporate and generals with agencies
2025-08-19
case woker input is removed for Generals.  A new agency page is added for auto-assignment

*/

let caseWorkerRow=<></>;
// || wptapp.AGENCY_COUNT>0
if (wptapp.PROCESS_AREA=='Corporate' )
	caseWorkerRow=	<tr>
		<td align='right' title={"Case Worker Name: "+wptapp.CASE_WORKER} >Case Worker:</td>
		<td align='left' colSpan="2" >
			<select name='CASE_WORKER' required value={wptapp.CASE_WORKER} onChange={(e)=>{callsetWptapp(e);}}  >
			{/*<option value='' >{caseWorker}</option>*/}
			<option value='' > * * * </option>
			{caseworkeroptions}
			</select>
			{/*
			&nbsp;<input type="checkbox" id="filtercw" onClick={(e)=>{callsetCaseworkeroptions(e.target.checked);}} />
			<label htmlFor="filtercw" className="hand"  >filter {wptapp.TC_ISLAND} {wptapp.PROCESS_AREA}</label>

			*/}
			
		</td>
	</tr>;
else
	caseWorkerRow=	<tr>
		<td align='right'  >Case Worker:</td>
		<td align='left' colSpan="2" >
		{agency.CASE_WORKER}
		</td>
	</tr>;
	

const returnPg=(wptapp.PROCESS_AREA??"")=="Government"?"gvtform":"wptform";	
	
  return (
    <>
	<div align='center' className="Acme" style={{marginBottom:"0px", marginTop:"9px", color:"brown",fontSize:"20px"}}  >
	{wptapp.PROCESS_AREA} Work Permit application {refnum} summary review and submit
	</div>
	{/* <span style={{width:"200px",backgroundColor:"green"}}>appe</span> */}
	<form method="POST" id="form1" onSubmit={(e)=>{submitwptapp(e);}} >
	<table align='center' border="0" >
	<tbody>
	<tr  key="tr_STEP1" >
	<td align='left' colSpan="3" >
		if the information below is correct then click the submit button
	</td>
	</tr>
	<tr  key="tr_MPE_CTRY" >
	<td align='right' >Country of Birth: </td>
	<td align='left' >{wptapp.MPE_BIRTH_COUNTRY}</td>
	</tr>
	<tr  key="tr_MPE_DOB" >
	<td align='right' >Date of Birth: </td>
	<td align='left' >{wptapp.CHR_MPE_DOB}</td>
	</tr>
	
	<tr  key="tr_MPE_PPT" >
	<td align='right' >Passport # & Country of Issue: </td>
	<td align='left' >{wptapp.MPE_PASSPORT_NBR+" "+wptapp.MPE_PASSPORT_CTY}</td>
	</tr>

	<tr  key="tr_AGENCY" >
	<td align='right' >Agency: </td>
	<td align='left' >{wptapp.AGENCY}</td>
	<td align='center' rowSpan="6" >
		{wptapp.REF_NUM!=undefined && <>
		<img src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/foto.png"} border='0' height="150" />
		<br/>
		{wptapp.MPE_FIRST_NAME+" "+wptapp.MPE_LAST_NAME}
		</>
		}	
	</td>
	</tr>
	<tr  key="tr_MPR_NAME" >
	<td align='right' >Employer: </td>
	<td align='left' >{wptapp.MPR_NAME}</td>
	</tr>
	<tr key="tr_OCCUPATION" >
	<td align='right' >Job Title: </td>
	<td align='left' >{wptapp.MPE_OCCUPATION}</td>
	</tr>
	<tr key="tr_OCCUP_CATEG" >
	<td align='right' >Business Type: </td>
	<td align='left' >
		<select name="OCC_CAT_ID" value={wptapp.OCC_CAT_ID} required onChange={(e)=>{handleChange(e);}} >
		<option value='' ></option>
		{occupcategoptions}
		</select>
	</td>
	</tr>
	{
	wptapp.PROCESS_AREA!="Government" &&
	<tr key="tr_WAGES" >
	<td align='right' >Salary: </td>
	<td align='left' >{ "$ "+(wptapp.MPE_SALARY_AMT??"")+" "+(wptapp.MPE_SALARY_PRD??"") }</td>
	</tr>
	}
	
	<tr key="tr_WRK_CONTRACT" >
	<td align='right' >Contract Dates: </td>
	<td align='left' >{wptapp.CHR_WRK_CONTRACT_START+" to "+wptapp.CHR_WRK_CONTRACT_END}</td>
	</tr>

	{
	wptapp.PROCESS_AREA!="Government" &&
	<tr key="tr_MED_CERT" >
	<td align='right' >Migrant Health Certificate Dates: </td>
	<td align='left' >{ (wptapp.CHR_MED_CERT_ISSUE_DATE??"")+" to "+(wptapp.CHR_MED_CERT_EXPIRE_DATE??"") }</td>
	</tr>
	}

	<tr key="tr_TC_ISLAND" >
	<td align='right' >Location: </td>
	<td align='left' >{wptapp.TC_ISLAND}</td>
	</tr>
	
	{caseWorkerRow}
	{/*
	<tr key="key_tr_LOCATION_ID" >
	<td align='right' >Location:</td>
	<td align='left' ><select key="input_LOCATION_ID" name='LOCATION_ID' defaultValue={wptapp.LOCATION_ID}   ><option defaultValue='' ></option>{locations}</select></td>
	</tr>
	
	*/}	
	</tbody>
	</table>
	
	
	
	

<p align='center' >  
        <a href="#" onClick={(e)=>{e.preventDefault(); navigate("/scanneddocs", {state:{wptapp:wptapp}});  }}
        >return to previous page</a>
		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		
		{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
		{
		!dowait.show && 
		<input type="submit" id='btnsubmitapp' className="button" value="submit application for processing"  />
		}
</p>  
</form>
	<div id="snackbar">&nbsp;</div>

	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			<img src='img/greentick.png' border='0' height='48' /> your application is submitted!
			<p>you should receive email after it is processed</p>			
			<p><button className="button" style={{width:"120px"}} onClick={(e)=>{navigate("/"+nextpg.name,{state:{WPT_APP_ID:wptapp.WPT_APP_ID}});}} >Ok</button></p>
			
				{/*
			<NavLink ref={navWpapps} to={"/wpapps"} 
			  state={{WPT_APP_ID:wptapp.WPT_APP_ID}}  >Ok</NavLink>
				
				*/}
			</div>
		</div>
	</div>

    </>
  );
  


};


export default RenderWpSummary;